"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
exports.GeoTopics = {
    SB_GeoOnLogin: __1.sbMsgBus.sbPrefix + "geo_sdk_login",
    SB_GeoOnLogout: __1.sbMsgBus.sbPrefix + "geo_sdk_logout",
    SB_HideRegulationMessageonUserLogin: __1.sbMsgBus.sbPrefix + "hideRegulationMessageonUserLogin",
    SB_ShowRegulationMessageonUserLogin: __1.sbMsgBus.sbPrefix + "showRegulationMessageonUserLogin",
    SB_HideHeaderLoader: __1.sbMsgBus.sbPrefix + "hideHeaderLoader",
    SB_GeoSdkTopic: __1.sbMsgBus.sbPrefix + "geo_sdk_topic"
};
//# sourceMappingURL=index.js.map